import { makeStyles } from '@bayon/commons';

export const useStyles = makeStyles(() => ({
  fullWidth: {
    minWidth: 'unset',
  },
}));
